export default __webpack_public_path__ + "static/media/portfolio-125.2566a7fa.jpg";